export default {
  haulers: 'Transportører',
  setup: 'Dumpere',
  driverExperience: 'Kjøreerfaring',
  users: 'Brukere',
};
